import React from 'react';
import { Helmet } from 'react-helmet';
import { Typography } from '@rcg/ui-react/lib/components';
import useStyles from './useStyles';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';

const ResultsFail = () => {
  const classes = useStyles();
  const getDictionaryValue = useDictionary(Dictionary);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className={classes.internalServerErrorSection}>
        <Typography variant="h5" className={classes.internalServerErrorHeader}>
          {getDictionaryValue(Dictionary.airInternalErrorTitle.key)}
        </Typography>
        <Typography variant="subtitle1" className={classes.internalServerErrorDescription}>
          {getDictionaryValue(Dictionary.airInternalErrorDescription.key)}
        </Typography>
      </div>
    </>
  );
};
export default ResultsFail;
